export const SMS_CONFIG_MODEL = {

    id : null,

    institutionId : null,

    token : '',

    senderId : '',

    peId : '',

    dcs : 0,

    flashSms : 0,

    active : true
};